import React from 'react';
import classNames from 'classnames';
import Button, { ButtonProps } from './Button';

const PrimaryButton = React.forwardRef<HTMLButtonElement, ButtonProps>(({ className, children, ...rest }, ref) => (
  <Button ref={ref} className={classNames(className, 'primary')} {...rest}>
    {children}
  </Button>
));

export default PrimaryButton;
